import React, { FC } from 'react'
import { TrainQuestionModalProps } from './types'
import * as LocalStyles from './styles'
import { useModalToggle } from '../hooks'
import { useQuestionTrainedStatus } from '../tableRow/hooks'
import { getButtonState } from '../util/button'
import { TrainQuestionModalDialog } from './TrainQuestionModalDialog'

export const TrainQuestionModal: FC<TrainQuestionModalProps> = ({ question }) => {
  const { toggleModal, isOpen } = useModalToggle()

  const { canBeTrained } = useQuestionTrainedStatus(question)

  const buttonState = getButtonState(canBeTrained, question.isTrained)

  return (
    <>
      <LocalStyles.TrainButton onClick={toggleModal} state={buttonState}>
        {question.isTrained ? 'Trained' : 'Train'}
      </LocalStyles.TrainButton>

      {isOpen && <TrainQuestionModalDialog question={question} canBeTrained={canBeTrained} onClose={toggleModal} />}
    </>
  )
}
